import React, { useContext, useEffect, useReducer } from 'react';
import styled from 'styled-components';
import { ConfirmationInstructions } from '@bb/domain/dist/types/AppointmentConfig';
import { useIsFirstRender } from 'hooks';
import { AuthContext } from 'contexts';
import { InputLabel, InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';
import SentrilockValidator from '../../../AccessValidators/SentrilockValidator';
import UploadEditPhotoButton from '../UploadEditPhotoButton';

const DEFAULT_TEXT =
  '**ATTN - OUT OF BOARD AGENTS** please ask LA to provide you Sentriconnect access to lockbox.';

const SentrilockV2: React.FC<AccessOptionProps> = ({
  listing,
  showingsConfig,
  setShowingsConfig,
  setIsValid,
}) => {
  const { auth } = useContext(AuthContext);
  const isFirstRender = useIsFirstRender();
  const [shouldGetLockboxes, setGetLockboxesFalse] = useReducer(
    () => false,
    true,
  );
  const [needsToApplyDefaultText, setNeedsToApplyDefaultTextFalse] = useReducer(
    () => false,
    !showingsConfig.instructions.sentrilockv2?.lbsn,
  );

  const showSentriLockAssignmentWarning = !auth.mls_numbers?.length;
  const isValid = Boolean(showingsConfig.instructions.sentrilockv2?.lbsn);

  useEffect(() => {
    setIsValid(isValid);
  }, [setIsValid, showingsConfig]);

  const setSentriLockInfo = (
    _info: Partial<ConfirmationInstructions['sentrilockv2']>,
  ) => {
    const info = { ..._info };
    if (!info?.details && needsToApplyDefaultText) {
      info.details = DEFAULT_TEXT;
      setNeedsToApplyDefaultTextFalse();
    }

    setShowingsConfig(prev => ({
      ...prev,
      instructions: {
        ...prev.instructions,
        sentrilockv2: {
          ...(prev.instructions.sentrilockv2 || {}),
          ...info,
        } as any,
      },
    }));
  };

  return (
    <>
      <StyledSentrilockValidatorWrapper $isValid={isValid}>
        <InputLabel label="Select Lockbox" required />
        <SentrilockValidator
          setGetLockboxesFalse={setGetLockboxesFalse}
          shouldGetLockboxes={shouldGetLockboxes}
          listingId={listing.id.toString()}
          listingReps={listing.reps}
          sentriLockInfo={showingsConfig.instructions.sentrilockv2 as any} // fix type
          setSentriLockInfo={setSentriLockInfo as any} // fix type
          pendingSentriLockAssignment={
            showingsConfig.pendingSentriLockAssignment
          }
          pendingSentriLockAssignmentRetryTime={showingsConfig.pendingSentriLockAssignmentRetryTime?.toString()}
          isOneDayCodeEnabled={
            showingsConfig.instructions.sentrilockv2?.isOneDayCodeEnabled
          }
          isFirstShowingAgentInstructionsRender={isFirstRender}
          showSentriLockAssignmentWarning={showSentriLockAssignmentWarning}
        />
      </StyledSentrilockValidatorWrapper>
      <UploadEditPhotoButton
        listingId={listing.id}
        lockboxPhoto={showingsConfig.lockboxPhoto}
        setLockboxPhoto={val => {
          setShowingsConfig(prev => ({
            ...prev,
            lockboxPhoto: val,
          }));
        }}
      />
      <div>
        <InputTextArea
          label="Other SentriLock instructions"
          labelExtra="(optional)"
          dataCy="showing-notification-sentrilock-details"
          value={showingsConfig.instructions.sentrilockv2?.details || ''}
          minHeight={100}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                sentrilockv2: {
                  ...(prev.instructions.sentrilockv2 || {}),
                  details: value,
                } as any,
              },
            }))
          }
        />
      </div>
    </>
  );
};

const StyledSentrilockValidatorWrapper = styled.div<{ $isValid: boolean }>`
  .sentrilock-validator-add-lockbox-link {
    ${({ $isValid }) => (!$isValid ? 'color: red;' : '')}
  }
`;

export default SentrilockV2;
